import { 
    FILTER_INSPECTION_MISSIONS, 
    FILTER_INSPECTION_MISSIONS_ERROR 
  } from '../action/inspectionMission';
  
  const initialState = {
    missions: [],
    loading: true,
    error: null,
  };
  
  const inspectionReducer = (state = initialState, action) => {
    switch (action.type) {
      case FILTER_INSPECTION_MISSIONS:
        return {
          ...state,
          missions: action.payload,
          loading: false,
          error: null,
        };
      case FILTER_INSPECTION_MISSIONS_ERROR:
        return {
          ...state,
          missions: [],
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default inspectionReducer;
  